import { Injectable } from '@angular/core';

// Demo mode serves the captured payloads in assets/demo-api instead of the live api.
// ?demo=1 on any route turns it on, ?demo=0 off; it holds for the browser session.
@Injectable({
  providedIn: 'root'
})
export class DemoService {

  private static storageKey = 'demo_mode';

  isActive = false;

  constructor() {

    this.isActive = this.load();

    // the first requests go out before the router has navigated
    if (typeof window !== 'undefined')
      this.applyQueryParam(new URLSearchParams(window.location.search).get('demo'));
  }

  applyQueryParam(value: string) {
    if (value == '1') this.setActive(true);
    if (value == '0') this.setActive(false);
  }

  setActive(isActive: boolean) {

    this.isActive = isActive;

    try {
      if (isActive) sessionStorage.setItem(DemoService.storageKey, '1');
      else sessionStorage.removeItem(DemoService.storageKey);
    }
    catch { }
  }

  private load() {
    try {
      return sessionStorage.getItem(DemoService.storageKey) == '1';
    }
    catch {
      return false;
    }
  }
}
